import React from "react";
import { Fade } from "react-awesome-reveal";
import AboutBanner from "../Assets/AboutBanner.jpg";
import "../Css/HomeAboutUs.css";


const HomeAboutUs = ({ aboutConent }) => {
  return (
    <>
      <section className="sectionDiv">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <Fade triggerOnce direction="left">
                <div
                  className="aboutPageImg"
                  style={{
                    background:
                      "url(https://www.baunat.com/library/photos/227959_212583-diamant-als-investering.jpg)",
                    backgroundSize: "100% 100%",
                  }}
                >
                  <img src={AboutBanner} alt="Melee Diamonds For Jewellery" />
                </div>
              </Fade>
            </div>

            <div className="col-md-6">
              <Fade triggerOnce direction="right">
           
                <h3 className="home-about-us-title mt-4">We Sejal Group </h3>
                <p
              dangerouslySetInnerHTML={{
                __html: aboutConent.paraOne,
              }}
            />
                   <p
              dangerouslySetInnerHTML={{
                __html: aboutConent.paraTwo,
              }}
            />
            <p>{aboutConent.paraThree}</p>
              </Fade>
            </div>
          
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeAboutUs;
